// extracted by mini-css-extract-plugin
module.exports = {"wrap":"eh-z","subtitle":"fh-z","contentWrap":"gh-z","imgWrap":"hh-z","heading":"ih-z","copy":"jh-z"};